import { ReactNode, useState } from "react";
import { PieChartOutlined, TableOutlined } from "@ant-design/icons";
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Chip,
  Grid,
} from "@mui/material";

type Props = {
  title: string;
  chart: ReactNode;
  table: ReactNode;
  headerAction?: ReactNode;
};

const VisualTabularCard = ({ title, chart, table, headerAction }: Props) => {
  const [view, setView] = useState<"Visual" | "Tabular">("Visual");

  return (
    <Card>
      <CardHeader
        sx={{ p: 2 }}
        title={title}
        action={
          <Grid container spacing={1} alignItems="center">
            {headerAction && <Grid item>{headerAction}</Grid>}
            <Grid item>
              <Chip
                icon={<PieChartOutlined />}
                label="Visual"
                color={view === "Visual" ? "primary" : "default"}
                onClick={() => setView("Visual")}
              />
            </Grid>
            <Grid item>
              <Chip
                label="Tabular"
                icon={<TableOutlined />}
                color={view === "Tabular" ? "primary" : "default"}
                onClick={() => setView("Tabular")}
              />
            </Grid>
          </Grid>
        }
      />
      <Divider />
      <CardContent>{view === "Visual" ? chart : table}</CardContent>
    </Card>
  );
};

export default VisualTabularCard;
